import { withStyles } from '@material-ui/core/styles';
import CustomTableScroll from './CustomTableScroll';
import styles from './styles';

export default withStyles(styles)(CustomTableScroll);
